import { useState } from 'react';
import { Link } from 'react-router-dom';

const faqs = [
  {
    q: 'Is TMM Insider really free forever?',
    a: 'Yes. TMM Insider is always free. You get community access, event announcements, RSVP ability, and the camp guide. No credit card, no catch. It\'s your free seat at the table.',
  },
  {
    q: 'What\'s the actual difference between Insider and VIP?',
    a: 'Insider gets you in the community. VIP gets you in early — and in front. Early RSVP access (24–48 hrs before public), VIP-only events, no RSVP fees on most events, partner discounts, and exclusive guides. If you\'re already showing up, VIP removes the friction.',
  },
  {
    q: 'How much is VIP?',
    a: '$12/month or $120/year (two months free). We push annual because it\'s the better deal — $10/month effectively, and you lock in your rate.',
  },
  {
    q: 'What are VIP-only events?',
    a: 'Smaller, more curated gatherings — think brunches with 8–12 moms, hosted wine nights, business + mom networking nights, and "off the calendar" pop-ups. Not more events. Better ones.',
  },
  {
    q: 'What are the Founding 50 spots?',
    a: 'The first 50 VIPs get a permanent "Founding Member" badge, a bonus perk (free event invite or exclusive merch), and recognition inside the community. Once those spots are gone, they\'re gone.',
  },
  {
    q: 'Can I cancel VIP anytime?',
    a: 'Yes. No long-term commitment. Cancel anytime with no penalty. If you go annual, you keep your access through the end of your billing year.',
  },
  {
    q: 'Do I need to live in Sugar Hill to join?',
    a: 'Nope — TMM serves moms across Gwinnett County and surrounding areas. If you\'re local to this region, you belong here.',
  },
];

export default function MembershipFAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  return (
    <>
      <section className="py-20 bg-gray-50">
        <div className="max-w-2xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <span className="text-xs font-bold tracking-widest uppercase text-pink-500 mb-3 block">Questions</span>
            <h2 className="text-3xl font-extrabold text-gray-900">Common Questions</h2>
          </div>

          <div className="space-y-3">
            {faqs.map((faq, i) => (
              <div
                key={i}
                className="bg-white rounded-xl border border-gray-100 overflow-hidden"
              >
                <button
                  onClick={() => setOpenIndex(openIndex === i ? null : i)}
                  className="w-full flex items-center justify-between px-6 py-4 text-left cursor-pointer group"
                >
                  <span className="text-sm font-bold text-gray-800 group-hover:text-rose-500 transition-colors pr-4">
                    {faq.q}
                  </span>
                  <div className="w-5 h-5 flex items-center justify-center shrink-0">
                    <i className={`${openIndex === i ? 'ri-subtract-line' : 'ri-add-line'} text-gray-400 text-sm`}></i>
                  </div>
                </button>
                {openIndex === i && (
                  <div className="px-6 pb-4">
                    <p className="text-sm text-gray-500 leading-relaxed">{faq.a}</p>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Next steps */}
      <section className="py-16 bg-white border-t border-gray-100">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 text-center">
          <p className="text-xs font-bold tracking-widest uppercase text-pink-500 mb-4">Already a member? Start here.</p>
          <h3 className="text-2xl font-extrabold text-gray-900 mb-2">Explore what&apos;s waiting for you</h3>
          <p className="text-sm text-gray-400 mb-10">
            Events, guides, local resources — it&apos;s all inside.
          </p>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 max-w-xl mx-auto">
            <Link
              to="/events"
              className="flex items-center gap-3 p-4 bg-pink-50 border border-pink-100 rounded-xl hover:bg-pink-100 transition-colors cursor-pointer group"
            >
              <div className="w-10 h-10 flex items-center justify-center bg-rose-500 rounded-lg shrink-0">
                <i className="ri-calendar-event-line text-white text-base"></i>
              </div>
              <div className="text-left">
                <p className="text-sm font-bold text-gray-900 group-hover:text-rose-500 transition-colors">Browse Events</p>
                <p className="text-xs text-gray-400">Upcoming local happenings</p>
              </div>
              <i className="ri-arrow-right-line text-pink-400 ml-auto"></i>
            </Link>
            <Link
              to="/mama-approved"
              className="flex items-center gap-3 p-4 bg-rose-50 border border-rose-100 rounded-xl hover:bg-rose-100 transition-colors cursor-pointer group"
            >
              <div className="w-10 h-10 flex items-center justify-center bg-rose-500 rounded-lg shrink-0">
                <i className="ri-shield-star-line text-white text-base"></i>
              </div>
              <div className="text-left">
                <p className="text-sm font-bold text-gray-900 group-hover:text-rose-500 transition-colors">Mama Approved</p>
                <p className="text-xs text-gray-400">VIP partner discounts</p>
              </div>
              <i className="ri-arrow-right-line text-rose-400 ml-auto"></i>
            </Link>
          </div>
        </div>
      </section>
    </>
  );
}
